﻿window.cObjetHebergementTarifMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Tarif"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau tarif"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data == 'undefined' && objet.data == null) { txt = "Tarif" }
        else {
            txt = objet.data.nom
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-money-bill-transfer'></i>");
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        $("<div style='overflow:hidden;text-overflow:ellipsis;width:100%;padding:0 3px;'>" + dataTemplate.nom + "</div>").appendTo(contentElement)
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<div style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</div>").appendTo(contentElement)
        $("<div style='' title='Modifié le " + dataPlus.dmo.toFrenchDateTime() + "'><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dmo.toDateIlya(true) + "</div>").appendTo(contentElement)
    }

    this.mCreateNewTarif = function (funcOk) {
        Me.objet.bddRef.mAjaxCall({
            command: "creationhebergementtarif"
        }, function (data) {
            var newData = Me.objet.bddRef.getObjet("hebergement_tarif", data.bddadd.hebergement_tarif[0].id_hebergement_tarif).data
            Me.objet.bddRef.triggerFunctionOnModifiedItemData("hebergement_tarif", "new", newData)
            funcOk(newData)
        })
    }

    this.mGetNewNomTarif = function () {
        var idx = 1
        while (Me.objet.bddRef.mGetArray("hebergement_tarif").filter(function (ch) { return ch.nom == "Tarif " + idx }).length > 0) {
            idx += 1
        }
        return "Tarif " + idx
    }

    this.mGetLstTarif = function () {
        return Me.objet.bddRef.mGetArray("hebergement_tarif")
    }

    this.mGetLstTarifPersonne = function (nbPers) {
        if (typeof nbPers == 'undefined') nbPers = null
        return Me.objet.bddRef.mGetArray("hebergement_tarif_personne")
            .filter(function (tarifPers) {
                return tarifPers.id_tarif == objet.data.id_tarif &&
                    ((nbPers == null) ||
                        (nbPers != null && nbPers >= tarifPers.nb_pers_min && nbPers <= tarifPers.nb_pers_max))
            }).sort(function (o1, o2) { return parseInt(o1.nb_pers_min) - parseInt(o2.nb_pers_min) })
    }

    this.mGetTarifPersonneSansCorrespondance = function (nbPers) {
        var tarifPers = null
        var lstTarifPersonne = this.mGetLstTarifPersonne()
        lstTarifPersonne.forEach(function (tafPers) {
            if (tarifPers == null || tafPers.nb_pers_max < nbPers) tarifPers = tafPers
        })
        if (tarifPers == null) tarifPers = lstTarifPersonne[0]
        return tarifPers
    }

    this.mGetTarifParPersonne = function (nbPers) {
        var lstTarifPers = this.mGetLstTarifPersonne(nbPers)
        if (lstTarifPers.length == 0) {
            return this.mGetTarifPersonneSansCorrespondance(nbPers)
        } else if (lstTarifPers.length == 1) { return lstTarifPers[0] }
        else { return lstTarifPers[0] }
    }

    this.mGetPrixPersonneNuit = function (dat, nbPers, nbNuitTotal) {
        var lst = objet.bddRef.mGetArray("hebergement_tarif_detail")
            .filter(function (o) { return o.id_hebergement_tarif == objet.data.id_hebergement_tarif })
        var lstPers = []
        while (lstPers.length == 0 && nbPers >= 1) {
            lstPers = lst.filter(function (o) { return o.nb_personne == nbPers })
            if (lstPers.length == 0) nbPers -= 1
        }

        if (nbPers == 0) {
            //on a pas trouvé de tarif en desous du nbpers
            return this.mGetPrixFromDate(dat)
        } else {
            while (nbNuitTotal > 0 && lstPers.filter(function (o) { return o.nb_nuit == nbNuitTotal }).length == 0) {
                nbNuitTotal -= 1
            }
            if (nbNuitTotal == 0) {
                //on a pas trouvé de tarif en desous du nbNuitTotal
                return this.mGetPrixFromDate(dat)
            } else {
                var tarifDetail = lstPers.filter(function (o) { return o.nb_nuit == nbNuitTotal })[0]
                var prix = objet.bddRef.getObjet(tarifDetail).objetMetier.mGetPrixFromDate(dat)
                return prix
            }

        }
    }

    this.mGetPrixFromDate = function (dat) {
        if (gestionDateNuite.isTarifNuitWeekEndVacances(dat) && objet.data.prix_ttc_we_vacances != 0) { return objet.data.prix_ttc_we_vacances }
        else if (gestionDateNuite.isTarifNuitWeekEnd(dat) && objet.data.prix_ttc_we != 0) { return objet.data.prix_ttc_we }
        else if (gestionDateNuite.isTarifNuitVacances(dat) && objet.data.prix_ttc_vacances != 0) { return objet.data.prix_ttc_vacances }
        else { return objet.data.prix_ttc }
    }

    this.mGetNewTarifPersonne = function () {
        var nbMin = 0
        var nbMax = 0
        this.mGetLstTarifPersonne().forEach(function (tarifPers) {
            if (parseInt(tarifPers.nb_pers_max) > nbMin) nbMin = parseInt(tarifPers.nb_pers_max)
        })
        nbMin += 1
        nbMax = nbMin + 1
        var tarifPersonne = Me.objet.bddRef.getObjet("hebergement_tarif_personne").mGetNewData()
        tarifPersonne.nb_pers_min = nbMin
        tarifPersonne.nb_pers_max = nbMax
        tarifPersonne.id_tarif = objet.data.id_tarif
        return tarifPersonne
    }

    this.mShowPopup = function (optionPopup) {
        if (!optionPopup) optionPopup = {}
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            width: 900,
            height: "100%",
            showTitle: true,
            showMaximize: true,
            title: "Tarif",
            buttons: [{
                icon: "fas fa-copy",
                txtTooltip: "Dupliquer le tarif",
                onClick: function (e) {
                    jaugeDemarrage.mShow()
                    objet.bddRef.mAjaxCall({
                        command: "dupliktarifhebergement",
                        id_hebergement_tarif: objet.data.id_hebergement_tarif
                    }, function (data) {
                        var newData = objet.bddRef.getObjet("hebergement_tarif", data.bddadd.hebergement_tarif[0].id_hebergement_tarif).data
                        objet.bddRef.triggerFunctionOnModifiedItemData("hebergement_tarif", "new", newData)
                        objet.bddRef.getObjet(newData).mShowPopup()
                        popup.hide()
                        mNotify("Le tarif a été dupliqué", "success", 6000)
                        jaugeDemarrage.mHide()
                    })
                },
                onContentReady: function (e) { }
            }],
            onDelete: function () {
                Me.objet.bddRef.getObjet(objet.data).mDelData()
            },
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "0")
                var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                $("<div/>").appendTo(dxScroll.content()).dxCtrlHebergementTarif({
                    bddCtrl: Me.objet.bddRef,
                    tarif: objet.data
                })
            },
            onHidden: function (e) {
                if (typeof optionPopup.onHidden != 'undefined') optionPopup.onHidden(e)
            }
        }).dxCtrlPopupBase("instance")
        popup.show();
    }

}